if (!customElements.get('multicolumn-slider')) {
  class MulticolumnSlider extends HTMLElement {
    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.multicolumn__items',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      if (!this.section || !this.sliderWrapper) {
        console.warn('MulticolumnSlider: Required elements not found');
        return;
      }

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items) || 4;
      this.tabletItems = parseInt(this.dataset.tabletItems) || 3;

      this.sliderInstance = false;
      this.focusHandlers = new Map();
      this.blockSelectHandler = null;

      if (!this.enableSlider) return;

      this.initSlider();
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);
      
      // Guard navigation elements
      const nextEl = this.section.querySelector(this.selectors.nextEl);
      const prevEl = this.section.querySelector(this.selectors.prevEl);

      const sliderOptions = {
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
            spaceBetween: columnGap.tablet,
            autoHeight: false,
          },
          1024: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.tabletLarge,
            autoHeight: false,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop,
            autoHeight: false,
          },
        },
        loop: true,
        threshold: 2,
      };

      // Only add navigation if elements exist
      if (nextEl && prevEl) {
        sliderOptions.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        // Theme editor support
        if (Shopify.designMode) {
          this.blockSelectHandler = (e) => {
            const blockElement = e.target.closest('[data-shopify-editor-block]');
            if (blockElement && this.contains(blockElement)) {
              const index = parseInt(blockElement.dataset.index);
              if (!isNaN(index) && this.sliderInstance?.slider) {
                this.sliderInstance.slider.slideToLoop(index);
              }
            }
          };
          document.addEventListener('shopify:block:select', this.blockSelectHandler);
        }

        // Accessibility - store handlers for cleanup
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          const handler = () => {
            const slide = element.closest('.swiper-slide');
            if (slide && this.sliderInstance?.slider) {
              const index = parseInt(slide.dataset.swiperSlideIndex);
              if (!isNaN(index)) {
                this.sliderInstance.slider.slideToLoop(index);
              }
            }
          };
          this.focusHandlers.set(element, handler);
          element.addEventListener('focusin', handler);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      if (this.sliderWrapper) {
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
      }
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }

    disconnectedCallback() {
      // Clean up block select handler
      if (this.blockSelectHandler) {
        document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      }

      // Clean up focus handlers
      if (this.focusHandlers) {
        this.focusHandlers.forEach((handler, element) => {
          element.removeEventListener('focusin', handler);
        });
        this.focusHandlers.clear();
      }

      this.destroySlider();
    }
  }

  customElements.define('multicolumn-slider', MulticolumnSlider);
}
